import React, {useContext, useReducer, useState} from 'react'
import {TableCell, TableRow} from '@material-ui/core';
import Tr from 'translations/Translations';
import moment from "moment";
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import WorkableIconDownloadButton from 'components/button/WorkableIconDownloadButton';
import DateFormats from "constants/DateFormats";
import iconWorksReducer from "libs/iconWorksReducer";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import {useParams} from "react-router";
import DemandAdditionalOffersOfferService from "services/DemandAdditionalOffersOfferService";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import {RoundType} from "constants/RoundType";
import DemandOffersAuctionService from "services/DemandOffersAuctionService";
import OfferFilesTableSignStatus from "../files/OfferFilesTableSignStatus";
import WorkableIconButton from "components/button/WorkableIconButton";
import SignatureIcon from "components/icon/SignatureIcon";
import OfferSectionContext from "context/OfferSectionContext";
import SupportModeContext from "context/SupportModeContext";
import {ContractorDocumentTypeLabel, ContractorDocumentTypeSelectItems} from "constants/ContractorDocumentType";
import {OfferMode} from "../../../../common/constants/OfferMode";
import WorkableIconEditButton from "components/button/WorkableIconEditButton";
import EditFilePopup from "../files/EditFilePopup";
import Select from "components/Select";
import getObjectValue from "libs/getObjectValue";
import {TrueFalseWithEmpty} from "constants/TrueFalseItems";
import HelpComponent from "../../../../../../../../../../components/HelpComponent";

function OfferEspdTableRow(
    {
        row,
        disabled,
        espdOnPositions,
        positionIdToOrderMap,
        mode,
        classes,
        roundType,
        passiveOfferForm,
        signFileAvailable,
        onSignDocument,
        bulkEdit,
        formikProps,
        index
    }) {
    const params = useParams();
    const purchaserOfferContext = useContext(PurchaserOfferContext)
    const contextSection = useContext(OfferSectionContext);
    const supportMode = useContext(SupportModeContext);
    const [editFile, setEditFile] = useState(null);

    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        download: false,
        edit: false,
        delete: false,
    });


    const onDownload = () => {
        dispatchIconWorks({type: 'download', works: true});
        let promise;


        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.getDownloadEspdFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId);
            break;
            case RoundType.ADDITIONAL_OFFERS:
                promise = DemandAdditionalOffersOfferService.getDownloadEspdFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId);
            break;
            case RoundType.AUCTION:
                promise = DemandOffersAuctionService.getDownloadEspdFile(params.id, params.stageId, mode, row.identity, purchaserOfferContext?.supplierId);
            break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }

        promise.finally(() => {
            dispatchIconWorks({type: 'download', works: false});
        })
    }

    const onDelete = () => {
        dispatchIconWorks({type: 'delete', works: true});
        DemandOffersOfferService.deleteEspdFile(params.id, params.stageId, row.identity, purchaserOfferContext?.supplierId)
            .catch(() => dispatchIconWorks({type: 'delete', works: false}));
    }

    const updateFile = (data) => {
        dispatchIconWorks({type: 'edit', works: true});
        let promise;
        switch (roundType) {
            case RoundType.BASE:
                promise = DemandOffersOfferService.editEspdFile(params.id, params.stageId, row.identity, mode, purchaserOfferContext?.supplierId, data)
                break;
            default:
                throw new Error("Unknown roundType: " + roundType)
        }
        promise.finally(() => dispatchIconWorks({type: 'edit', works: false}));
        setEditFile(null);
    }

    return (<TableRow>
        <TableCell>{row.file.name}</TableCell>
        <TableCell>{moment(row.file.insertDate).format(DateFormats.DATETIME_FORMAT)}</TableCell>
        <TableCell className={classes.typeColumn}>
            {bulkEdit ?
                <Select
                    className={classes.typeColumn}
                    id={`form.${index}.containsRodo`}
                    formikProps={formikProps}
                    items={TrueFalseWithEmpty}
                    disabled={disabled}
                />
                : TrueFalseWithEmpty.find(x => x.value === row.containsRodo).label}
        </TableCell>
        <TableCell className={classes.typeColumn}>{bulkEdit ?
            <Select
                className={classes.typeColumn}
                id={`form.${index}.documentType`}
                formikProps={formikProps}
                items={ContractorDocumentTypeSelectItems(getObjectValue(`form.${index}.documentType`, formikProps.values, null))}
                disabled={disabled}
            />
            : ContractorDocumentTypeLabel(row.documentType)}
        </TableCell>
        <TableCell><HelpComponent text={`${row.file.fileSize}, SHA256: ${row.file.sha256}`}></HelpComponent></TableCell>
        {espdOnPositions &&
            <TableCell>{Tr('part_x', {x: positionIdToOrderMap[`positionId_${row.positionId}`]})}</TableCell>}

        {(!purchaserOfferContext && (!!contextSection.digitalSign || passiveOfferForm)) && <TableCell className={classes.buttonColumn}>
            <OfferFilesTableSignStatus row={row} />
        </TableCell>}
        {
            signFileAvailable && <TableCell className={classes.buttonColumn}>
                {!!row.signatureConfiguration &&
                    <WorkableIconButton
                        tooltip={Tr('sign_document')}
                        Icon={SignatureIcon}
                        onClick={() => onSignDocument(row)}
                        disabled={supportMode}
                    />
                }
            </TableCell>
        }

        <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconDownloadButton
                onClick={() => onDownload()}
                disabled={iconWorks.anyWorks || supportMode}
                working={iconWorks.download}
            />}
        </TableCell>
        {!(disabled || mode === OfferMode.PLACED) && (!purchaserOfferContext || mode === OfferMode.EDIT) && <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconEditButton
                tooltip={Tr('edit_type')}
                disabled={iconWorks.anyWorks || (disabled || mode === OfferMode.PLACED) || supportMode}
                working={iconWorks.edit}
                onClick={() => setEditFile(row)}
            />}
            {!!editFile &&
                <EditFilePopup
                    file={editFile}
                    onCancel={() => setEditFile(null)}
                    onUpdate={(data) => updateFile(data)}
                />
            }
        </TableCell>}
        {!(disabled || mode === OfferMode.PLACED) && <TableCell className={classes.buttonColumn}>
            {!row.inaccessible && <WorkableIconDeleteButton
                tooltip={Tr('delete')}
                onClick={onDelete}
                disabled={iconWorks.anyWorks || (disabled || mode === OfferMode.PLACED) || supportMode}
                working={iconWorks.delete}
            />}
        </TableCell>}
    </TableRow>)
}

OfferEspdTableRow.propTypes = {};

export default OfferEspdTableRow;